import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { OfficialGrade } from 'routes/HumanResourcesModule/Settings/HrGrade/helpers/type';
import { RQAPICall } from 'store/APIClient';

const GRADE_MAPPING_API_KEY = 'official_grades';

export const useGetOfficialGrades = (): UseQueryResult<OfficialGrade[]> => {
    const endpoint = 'human_resources/hr_grade/official_grades';

    return useQuery({
        queryKey: [GRADE_MAPPING_API_KEY],
        queryFn: async () => {
            const getResponse = await RQAPICall({
                endpoint,
            });
            return getResponse.content.data;
        },
        meta: {
            useGlobalOnError: true,
        },
    });
};
